// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import qs from 'qs';
import { initialize } from 'redux-form';
import TranslatableOption from '../components/forms/Fields/TranslatableOption.jsx';
import * as PowerControlUnitsActions from '../redux/actions/powerControlUnits.actions';
import * as LockActions from '../redux/actions/lock.actions';
import * as AreaActions from '../redux/actions/area.actions';
import * as ModalActions from '../redux/actions/modal.actions';
import * as UtilsActions from '../redux/actions/utils.actions';
import PowerControlUnitsTableView from '../components/PowerControlUnits/PowerControlUnitsTableView.jsx';
import PowerControlUnitsOperationalSection from '../components/PowerControlUnits/PowerControlUnitsOperationalSection.jsx';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import OperationalView from '../components/OperationalView/OperationalView.jsx';

@connect(state => ({
  powerControlUnits: state.powerControlUnits,
  themeName: state.settings.items.theme.data.themeName,
  areas: state.areas.data.content,
  routing: state.router,
}))
class EnergyManagementUnits extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      searchText: '',
    };
  }

  async componentDidMount() {
    const { routing, dispatch } = this.props;
    dispatch(LockActions.fetchLocks(0, false, 200));
    this.onFetchPowerControlUnits();
    const { pcuId } = qs.parse(routing && routing.location ? routing.location.search : '', { ignoreQueryPrefix: true });
    if (pcuId) {
      this.onSelectPCU({ id: pcuId });
    }
  }

  async onFetchPowerControlUnits() {
    const { dispatch } = this.props;
    this.setState({ isLoading: true });
    try {
      await dispatch(PowerControlUnitsActions.fetchPowerControlUnits());
    } catch (error) {
      console.error('Error fetching power control units:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async onSelectPCU(pcu) {
    const { dispatch } = this.props;
    if (!pcu || !pcu.id) {
      return;
    }
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const detail = await dispatch(PowerControlUnitsActions.fetchPowerControlUnit(pcu.id));
      dispatch(PowerControlUnitsActions.selectPowerControlUnit(detail));
      dispatch(PowerControlUnitsActions.setOperationalMode(true));
      dispatch(initialize('PowerControlUnitDetailsForm', detail));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }

  onChangePage(page) {
    const { dispatch } = this.props;
    this.setState({ isLoading: true });
    dispatch(PowerControlUnitsActions.fetchPowerControlUnits(page))
      .finally(() => this.setState({ isLoading: false }));
  }

  onChangeRowsPerPage(pageSize) {
    const { dispatch } = this.props;
    this.setState({ isLoading: true });
    dispatch(PowerControlUnitsActions.fetchPowerControlUnits(0, false, pageSize))
      .finally(() => this.setState({ isLoading: false }));
  }

  onRefresh() {
    this.onFetchPowerControlUnits();
  }

  onSearchTextChange(searchText) {
    this.setState({ searchText });
  }


  onPowerStateFilterChange(value) {
    const { dispatch } = this.props;
    const state = value && value !== '' ? value : null;
    dispatch(PowerControlUnitsActions.setPowerControlUnitsFilter('state', state));
    this.onFetchPowerControlUnits();
  }

  onAutomationFilterChange(value) {
    const { dispatch } = this.props;
    const enabled = value === '' || value === null || value === undefined ? null : value === 'true' || value === true;
    dispatch(PowerControlUnitsActions.setPowerControlUnitsFilter('automationEnabled', enabled));
    this.onFetchPowerControlUnits();
  }

  onCloseOperationalView() {
    const { dispatch } = this.props;
    dispatch(PowerControlUnitsActions.setOperationalMode(false));
    dispatch(PowerControlUnitsActions.selectPowerControlUnit({}));
  }

  async onDeletePCU(pcuId) {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="deletePCUConfirm" />,
        onConfirmText: <Entity entity="confirm" />,
        onConfirm: () => this.onDeletePCUConfirm(pcuId),
        onCancelText: <Entity entity="cancel" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeletePCUConfirm(pcuId) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      await dispatch(PowerControlUnitsActions.deletePowerControlUnit(pcuId));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuDeleteSuccess" /></h6>),
        },
      }));
      this.onCloseOperationalView();
      this.onFetchPowerControlUnits();
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="pcuSaveError" /></h6>),
        },
      }));
    }
  }

  onPCUEditConfirmed(pcu) {
    const { dispatch } = this.props;
    dispatch(PowerControlUnitsActions.selectPowerControlUnit(pcu));
    this.onFetchPowerControlUnits();
  }

  onPCUCreateConfirmed(pcu) {
    const { dispatch } = this.props;
    dispatch(PowerControlUnitsActions.setOperationalMode(false));
    this.onFetchPowerControlUnits();
  }

  render() {
    const { powerControlUnits, themeName, areas } = this.props;
    const { isLoading, searchText } = this.state;
    const selectedPCU = powerControlUnits.selectedPCU;
    const isOperationalMode = powerControlUnits.isOperationalMode;


    const powerStateOptions = [
      { value: 'ON', label: 'ON' },
      { value: 'OFF', label: 'OFF' },
      { value: 'GRACE_PERIOD', label: 'Grace Period' },
      { value: 'INHIBITED', label: 'Inhibited' },
    ];

    const automationOptions = [
      { value: 'true', label: L20NContext.getSync('enabled') },
      { value: 'false', label: L20NContext.getSync('disabled') },
    ];

    const powerStateSelectableOptions = [
      (
        <Entity
          key="allPowerStates"
          componentClass={TranslatableOption}
          value=""
          componentAttribute="text"
          entity="allPowerStates"
        />
      ),
      ..._.map(powerStateOptions, stateOption => (
        <option value={stateOption.value} key={stateOption.value}>
          {stateOption.label}
        </option>
      )),
    ];

    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <PresentationalViewHeader
          themeName={themeName}
          title={<Entity entity="energyManagementUnits" />}
          searchPlaceholderEntityName="searchByName"
          onFilterChange={(value) => this.onSearchTextChange(value)}
          onRefresh={() => this.onRefresh()}
          selectableFieldName2="powerState"
          selectableOptions2={powerStateSelectableOptions}
          onSelectOption2={(value) => this.onPowerStateFilterChange(value)}
        />
        <div style={{ padding: '10px 20px', display: 'flex', alignItems: 'center', gap: 10, borderBottom: '1px solid #e0e0e0' }}>
          <span style={{ fontWeight: 'bold', marginRight: 10 }}>
            <Entity entity="automationStatus" />:
          </span>
          <select 
            style={{ 
              padding: '8px 12px', 
              borderRadius: 4, 
              border: '1px solid #ccc',
              fontSize: 14,
              minWidth: 150,
              cursor: 'pointer'
            }}
            onChange={(e) => {
              this.onAutomationFilterChange(e.target.value);
            }}
          >
            <option value="">{L20NContext.getSync('automationAny')}</option>
            {automationOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: 20 }}>
          <PowerControlUnitsTableView
            selectedPCU={selectedPCU}
            isLoading={isLoading}
            onSelectPCU={(pcu) => this.onSelectPCU(pcu)}
            onChangePage={(page) => this.onChangePage(page)}
            onChangeRowsPerPage={(pageSize) => this.onChangeRowsPerPage(pageSize)}
            onRefresh={() => this.onRefresh()}
          />
        </div>
        <OperationalView
          themeName={themeName}
          isVisible={isOperationalMode}
          onClose={() => this.onCloseOperationalView()}
          onDelete={selectedPCU && selectedPCU.id ? () => this.onDeletePCU(selectedPCU.id) : null}
          title={selectedPCU && selectedPCU.name ? selectedPCU.name : <Entity entity="newPowerControlUnit" />}
          style={{ paddingBottom: 0 }}
        >
          <PowerControlUnitsOperationalSection
            onPCUEditConfirmed={(pcu) => this.onPCUEditConfirmed(pcu)}
            onPCUCreateConfirmed={(pcu) => this.onPCUCreateConfirmed(pcu)}
          />
        </OperationalView>
      </div>
    );
  }
}

export default EnergyManagementUnits;
